import React from 'react'
import content from './contentmapservices';
import { FaChartArea } from 'react-icons/fa'; 
	 
function ServicesContent(props){
	return(
		   <section class="section-services">
   
	  <section id="services">
      <div class="container">
        <div class="section-header">
          <h2>{props.title}</h2>
          <p>We offer an on site service and repairs lab where we can service Most Major Brands of Hearing Aids, typically the same day. Occassionally, aids do need to be sent to the factory for severe repairs. They are sent out by overnight service and returned as quickly as possible. Our goal is to quickly return our patients to satisfactory hearing with as little disruption as possible.</p>
        </div>
 <div class="row">
 {content.map((item, index) => (
					
						 <div class="col-lg-6">
						  <div class="box wow fadeInLeft">
						   <div class="icon"><i class=""><item.userProfile /></i></div>
							<h4 class="title">{item.title}</h4>
							<p>{item.description}</p>
 						</div>
 					</div>
				))}

 </div>

        

      </div>
    </section>
	  </section>
		   

)
	}
	
export default ServicesContent